
import React from 'react';
import { Profession } from '@/lib/professionTypes';
import { Badge } from "@/components/ui/badge";
import { getCategoryIcon } from './ProfessionUtils';

interface SelectedProfessionBadgesProps {
  selectedProfessions: string[];
  professions: Profession[];
  onRemoveProfession: (professionId: string) => void;
}

const SelectedProfessionBadges: React.FC<SelectedProfessionBadgesProps> = ({
  selectedProfessions,
  professions,
  onRemoveProfession
}) => {
  if (selectedProfessions.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-2 mb-4">
      {selectedProfessions.map(profId => {
        const profession = professions.find(p => p.id === profId);
        const Icon = getCategoryIcon(profession?.category || 'Egyéb');
        
        return (
          <Badge 
            key={profId} 
            variant="secondary"
            className="px-2 py-1 flex items-center gap-1"
          >
            <Icon className="h-4 w-4" />
            {profession?.name || profId}
            <button 
              className="ml-1 text-xs"
              onClick={() => onRemoveProfession(profId)}
            >
              ✕
            </button>
          </Badge>
        );
      })}
    </div>
  );
};

export default SelectedProfessionBadges;
